import _ from 'lodash'
import { mapGetters } from 'vuex'

export default () => {
  return {
    template: '#template__newsgrid',
    props: {
      buttontitle: {
        type: String
      },
      articlefeed: {
        type: Array
      }
    },
    computed: {
      ...mapGetters({
        feed: 'newsfeed/items',
        mobile: 'viewport/mobile'
      }),
      columns () {
        if (this.mobile) return false
        let cols = this.group(this.items, 3)
        return cols
      },
      columnview () {
        return this.columns && this.mobile !== true
      },
      items () {
        return (this.articlefeed) ? this.articlefeed : (this.feed ? this.feed : [])
      }
    },
    methods: {
      group (which, howmany) {
        return _.reduce(_.range(howmany), ({which, result, howmany}, chunkIndex) => {
          const n = Math.ceil(which.length / howmany)
          const items = _.take(which, n)
          result.push(items)
          return {
            which: _.drop(which, n),
            result,
            howmany: howmany - 1
          }
        }, {
          which,
          result: [],
          howmany
        }).result
      }
    }
  }
}



// WEBPACK FOOTER //
// ./assets/js/components/newsgrid.js